import React from "react";
import { TextField, useTheme } from "@mui/material";

const BasicInfoSection = ({ name, location, onChange }) => {
  const theme = useTheme();
  return (
    <>
      <TextField
        label="Name"
        value={name}
        onChange={(e) => onChange("name", e.target.value)}
        fullWidth
        sx={{
          '& .MuiInputLabel-root': {
            color: theme.palette.text.primary, // Changed to a standard theme text color
          }
        }}
      />
      <TextField
        label="Location"
        value={location}
        onChange={(e) => onChange("location", e.target.value)}
        fullWidth
        sx={{
          '& .MuiInputLabel-root': {
            color: theme.palette.text.primary, // Changed to a standard theme text color
          }
        }}
      />
    </>
  );
};

export default BasicInfoSection;